export default function trainingDirective() {
  return {
    template: require('./training.html'),
    controller: 'TrainingController',
    controllerAs: 'trainingVM',
    bindToController: true,
    replace: true,
  };
}
